<template>
  <nav
    v-if="isLoggedIn"
    class="navbar navbar-expand-lg sticky-top profile-navbar shadow-sm py-2 px-4"
  >
    <div class="container-fluid">
      <router-link
        to="/dashboard"
        class="navbar-brand d-flex align-items-center me-0"
      >
        <div class="logo-wrapper me-2">
          <img src="../assets/task logo.png" alt="logo" class="logo-img" />
        </div>
        <span class="logo-text fw-bold fs-4"
          >Tasks<span class="brand-accent">App</span></span
        >
      </router-link>

      <a
        class="btn btn-primary d-lg-none"
        data-toggle="collapse"
        href="#navContent"
        role="button"
        aria-expanded="false"
        aria-controls="multiCollapseExample1"
      >
        <i class="fas fa-bars"></i>
      </a>

      <div class="collapse navbar-collapse" id="navContent">
        <ul class="navbar-nav mx-auto mb-2 mb-lg-0 text-center">
          <li class="nav-item">
      <router-link :to="selectedGroupId ? `/dashboard/${selectedGroupId}` : '/dashboard'" class="nav-link custom-link" >
   <i class="fas fa-th-large text-dark"></i>  <span>Dashboard</span> 
</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link custom-link" to="/taskly">
              <i class="fas fa-tasks text-dark"></i> <span>Taskly</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link custom-link" to="/post">
              <i class="fas fa-pen text-blue-500 text-dark"></i> <span>post</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link custom-link" to="/settings">
               <i class="fas fa-cog fa-spin-hover me-2 text-dark"></i><span>settings</span>
            </router-link>
          </li>
        </ul>
<div class="dropdown notification-dropdown mr-3">
  <button class="btn position-relative border-0 p-1 shadow-none" type="button" data-toggle="dropdown">
    <i class="fas fa-bell fs-4 text-muted"></i>
    <span v-if="notifications.length > 0" class="notif-badge-circle">
      {{ notifications.length }}
    </span>
  </button>

  <div class="dropdown-menu dropdown-menu-right shadow-lg border-0 rounded-lg mt-3 custom-dropdown-fix" style="width: 300px">
    <div class="px-3 py-2 border-bottom bg-light d-flex justify-content-between align-items-center">
      <span class="font-weight-bold text-dark small">Notifications Center</span>
    </div>

    <div class="notification-scroll-container custom-scrollbar">
      
      <div class="notif-section-header">Team Tasks</div>
      <div v-if="teamNotifications.length === 0" class="p-2 text-center text-muted small">No team tasks</div>
      <div v-for="(note, index) in teamNotifications" :key="'t-'+index" class="dropdown-item d-flex align-items-start p-3 border-bottom text-wrap bg-team">
        <div :class="'mr-2 p-2 rounded-circle bg-white text-' + note.type"><i :class="'fas ' + note.icon"></i></div>
        <p class="mb-0 small font-weight-bold text-dark">{{ note.message }}</p>
      </div>

      <div class="notif-section-header">Personal Tasks</div>
      <div v-if="personalNotifications.length === 0" class="p-2 text-center text-muted small">No personal tasks</div>
      <div v-for="(note, index) in personalNotifications" :key="'p-'+index" class="dropdown-item d-flex align-items-start p-3 border-bottom text-wrap">
        <div :class="'mr-2 p-2 rounded-circle bg-light text-' + note.type"><i :class="'fas ' + note.icon"></i></div>
        <p class="mb-0 small text-dark">{{ note.message }}</p>
      </div>
    </div>

    <button v-if="notifications.length > 0" class="btn btn-block text-primary small font-weight-bold py-2" @click="clearNotifications">Clear All</button>
  </div>
</div>
        <div class="dropdown social-notification-dropdown me-3">
          <button
            class="btn position-relative border-0 p-1 shadow-none"
            type="button"
            @click="toggleSocialDropdown"
          >
            <i class="fas fa-comment-dots fs-4 text-primary"></i>
            <span
              v-if="unreadSocialCount > 0"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger shadow-sm"
              style="font-size: 0.65rem; padding: 0.35em 0.65em"
            >
              {{ unreadSocialCount }}
            </span>
          </button>

          <ul
            v-if="showSocialDropdown"
            class="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-4 mt-3 show animate__animated animate__fadeIn"
            style="width: 340px; display: block; right: 0; left: auto"
          >
            <li
              class="px-3 py-3 border-bottom bg-light rounded-top-4 sticky-top"
            >
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-bold text-dark">Social Alerts</span>
                <button
                  v-if="unreadSocialCount > 0"
                  @click="markSocialAsRead"
                  class="btn btn-link btn-sm p-0 text-primary text-decoration-none fw-bold"
                >
                  Mark all as read
                </button>
              </div>
            </li>

            <div class="notification-scroll-container custom-scrollbar">
              <li
                v-if="socialNotifications.length === 0"
                class="p-5 text-center"
              >
                <i
                  class="fas fa-bell-slash d-block mb-2 text-muted opacity-50 fs-2"
                ></i>
                <p class="small text-muted mb-0">No new alerts found</p>
              </li>

              <li v-for="note in socialNotifications" :key="note.id">
                <router-link
                  :to="'/post#post-' + note.post_id"
                  @click="handleNotificationClick(note)"
                  class="dropdown-item d-flex align-items-center p-3 border-bottom text-wrap transition-all text-decoration-none"
                  :class="{ 'bg-unread': !note.is_read }"
                >
                  <div class="position-relative">
                    <img
                      :src="
                        note.senderProfile || 'https://via.placeholder.com/40'
                      "
                      class="rounded-circle me-3 shadow-sm"
                      width="40"
                      height="40"
                      style="object-fit: cover"
                    />
                    <span v-if="!note.is_read" class="unread-dot"></span>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-0 small text-dark leading-tight">
                      <span class="fw-bold text-primary">{{
                        note.senderName
                      }}</span>
                      {{ note.message }}
                    </p>
                    <div class="d-flex align-items-center mt-1">
                      <i
                        class="far fa-clock text-muted me-1"
                        style="font-size: 0.65rem"
                      ></i>
                      <small class="text-muted" style="font-size: 0.7rem">{{
                        formatTime(note.created_at)
                      }}</small>
                    </div>
                  </div>
                </router-link>
              </li>
            </div>
          </ul>
        </div>

        <div
          class="user-controls-wrapper d-flex align-items-center justify-content-center"
        >
          <div class="user-badge me-3 d-lg-flex">
            <div class="text-end me-2">
              <div class="user-greeting">Welcome!</div>
              <div class="user-status">Online</div>
            </div>
            <div class="avatar-mini">
              <img :src="userAvatar" alt="user" />
            </div>
          </div>

          <button @click="logout" class="btn btn-logout shadow-sm">
            <i class="fas fa-power-off"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { socialNotificationService } from "@/services/socialNotifacationServicee";
export default {
  name: "NavBar",
  data() {
    return {
      isLoggedIn: !!localStorage.getItem("token"),
      notificationTimer: null,
      socialNotifications: [],
      showSocialDropdown: false,
    };
  },
  computed: {
    // get current user from store
    currentUser() {
      return this.$store.state.user;
    },
    // get image url by default task logo.png
    userAvatar() {
      if (this.currentUser && this.currentUser.profile_img) {
        return this.currentUser.profile_img;
      }
      return require("../assets/task logo.png");
    },
    safeNotifications() {
      return Array.isArray(this.notifications) ? this.notifications : [];
    },
    notifications() {
      return this.$store.state.notifications;
    },
    unreadSocialCount() {
      return this.socialNotifications.filter((n) => n.is_read == 0).length;
    },
    teamNotifications() {
    return this.notifications.filter(n => n.scope === 'group');
  },
  // Get only Personal Tasks (Scope: personal or empty)
  personalNotifications() {
    return this.notifications.filter(n => n.scope !== 'group');
  }
  },
  watch: {
    $route() {
      this.isLoggedIn = !!localStorage.getItem("token");
    },
    isLoggedIn(newVal) {
      if (newVal) {
        this.refreshAllData();
      }
    },
  },
  methods: {
    toggleSocialDropdown() {
      this.showSocialDropdown = !this.showSocialDropdown;
      if (this.showSocialDropdown) {
        this.fetchSocialNotifications();
      }
    },

    async fetchSocialNotifications() {
      try {
        const res = await socialNotificationService.getNotifications();
        this.socialNotifications = res.data;
      } catch (err) {
         throw err;
      }
    },

    async markSocialAsRead() {
      try {
        await socialNotificationService.markAsRead();

        this.socialNotifications = this.socialNotifications.map((n) => ({
          ...n,
          is_read: 1,
        }));
      } catch (err) {
         throw err;
      }
    },

    formatTime(date) {
      return new Date(date).toLocaleString();
    },

    refreshAllData() {
      this.$store.dispatch("getNotifications");
    },
    async logout() {
      if (this.notificationTimer) {
        clearInterval(this.notificationTimer);
        this.$store.commit("getNotifications", []);
      }
      this.$store.commit("getNotifications", []);
      localStorage.clear();
      this.isLoggedIn = false;
      this.$router.push("/auth");
    },

    checkCriticalNotifications() {
      if (
        !this.$store.state.notifications ||
        !Array.isArray(this.notifications)
      ) {
        return;
      }
      const overdueAlert = this.notifications.find((n) => n.type === "danger");
      if (overdueAlert) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: "Deadline Alert",
          text: overdueAlert.message,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    },

    clearNotifications() {
      this.$store.commit("getNotifications", []);
    },
    async handleNotificationClick(note) {
      this.showSocialDropdown = false;

      if (!note.is_read) {
        try {
          await socialNotificationService.markAsRead();
          note.is_read = 1;
        } catch (err) {
           throw err;
        }
      }
    },
  },

  async mounted() {
    if (this.isLoggedIn) {
      this.refreshAllData();

      this.notificationTimer = setInterval(() => {
        this.$store.dispatch("getNotifications");
      }, 300000);
    }
    await this.fetchSocialNotifications();
  },
  beforeUnmount() {
    if (this.notificationTimer) {
      clearInterval(this.notificationTimer);
    }
  },
};
</script>

<style scoped lang="scss">
.profile-navbar {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  z-index: 1050;  

  .brand-accent {
    color: #198754;
  }
  .logo-text {
    color: #dc3545;
    letter-spacing: -0.5px;
  }

  .logo-wrapper {
    width: 65px;
    height: 65px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 50%;
    }
  }

  
  .custom-link {
    color: #444 !important;  
    font-size: 0.95rem;
    font-weight: 600;
    padding: 10px 20px !important;
    margin: 0 5px;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 1.1rem;
      color: #6c757d;
      transition: inherit;
    }

    &:hover {
      background: rgba(25, 135, 84, 0.08);
      color: #198754 !important;
      i {
        color: #198754;
        transform: scale(1.1);
      }
    }

    &.router-link-active {
      background: #198754;
      color: white !important;
      box-shadow: 0 4px 12px rgba(25, 135, 84, 0.25);
      i {
        color: white;
      }
    }
  }

  .custom-toggler {
    color: #198754;
    font-size: 1.5rem;
    &:focus {
      box-shadow: none;
    }
  }

  .user-badge {
    background: #f8f9fa;
    padding: 5px 12px;
    border-radius: 30px;
    border: 1px solid #eee;
    .user-greeting {
      font-size: 0.7rem;
      color: #888;
      margin-bottom: -2px;
    }
    .user-status {
      font-size: 0.75rem;
      color: #198754;
      font-weight: bold;
    }
  }

  .avatar-mini {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #198754;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .btn-logout {
    background: #fff;
    color: #dc3545;
    border: 1px solid #f8d7da;
    padding: 10px 22px;
    border-radius: 14px;
    font-weight: 700;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
      background: #dc3545;
      color: white;
      transform: scale(1.03);
    }
  }
}

 
@media (max-width: 991px) {
  .navbar-collapse {
    background: white;
    margin-top: 15px;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
  .custom-link {
    margin: 5px 0;
    justify-content: center;
  }
  .user-controls-wrapper {
    flex-direction: column;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
}

/* Custom styles for Notifications */
.notification-dropdown {
  .dropdown-menu {
    /* Smooth entrance animation */
    animation: slideIn 0.3s ease-out;

    /* Soft badges colors */
    .bg-light.text-danger {
      background-color: rgba(220, 53, 69, 0.1) !important;
    }
    .bg-light.text-info {
      background-color: rgba(13, 202, 240, 0.1) !important;
    }
    .bg-light.text-success {
      background-color: rgba(25, 135, 84, 0.1) !important;
    }
  }

  .dropdown-item {
    transition: background 0.2s;
    &:active {
      background-color: #f8f9fa;
      color: inherit;
    }
  }
}
 
.notification-scroll-container {
  max-height: 400px;  
  overflow-y: scroll !important;
  overflow-x: hidden;
   
}

 
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;  
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;  
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #ccc;  
  border-radius: 10px;
  transition: background 0.3s;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #0d6efd;   
}

 
.notification-scroll-container {
  scroll-behavior: smooth;
}

 
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
 
.notif-badge-circle {
  position: absolute;
  top: -2px;
  right: -2px;
  background-color: #dc3545;
  color: white;
  min-width: 18px;
  height: 18px;
  border-radius: 50% !important; /* Force circle */
  font-size: 0.65rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid white;
}

/* 2. Scroll Container Fix */
.notification-scroll-container {
  max-height: 400px;  
  overflow-y: scroll !important; /* Force scroll appearance */
  display: block;
}

 
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;  
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #ccc; 
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #999; 
}

 
.notif-section-header {
  background: #f8f9fa;
  padding: 5px 12px;
  font-size: 0.65rem;
  font-weight: bold;
  color: #999;
  text-transform: uppercase;
  border-bottom: 1px solid #eee;
}
.bg-team { background-color: rgba(0, 123, 255, 0.03); }
</style>


 
        
  


 
 
   